var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 11.125L11.8125 1.625C12.5938 0.84375 13.875 0.84375 14.6562 1.625L15.875 2.84375C15.9688 2.9375 16.0625 3.0625 16.125 3.15625C16.6562 3.9375 16.5625 5 15.875 5.6875L6.375 15.1875C6.34375 15.2188 6.28125 15.25 6.25 15.3125C5.9375 15.5625 5.59375 15.75 5.21875 15.875L1.4375 16.9688C1.1875 17.0625 0.90625 17 0.71875 16.7812C0.5 16.5938 0.4375 16.3125 0.5 16.0625L1.625 12.2812C1.75 11.8438 2 11.4375 2.3125 11.125ZM3.0625 12.7188L2.34375 15.1562L4.78125 14.4375C4.96875 14.375 5.15625 14.2812 5.3125 14.125L12.4688 6.96875L10.5 5.03125L3.375 12.1875C3.34375 12.1875 3.34375 12.2188 3.3125 12.25C3.1875 12.375 3.125 12.5312 3.0625 12.7188Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8745c19644ffe6ab63c904116d4ed276.svg";
export { ForwardRef as ReactComponent };